import apiConfig from '../../../apiConfig';

export type ServiceForDateSelection = {
  service_id: number;
  service_name: string;
  price: number;
  duration_minutes: number;
  category_id: number | null;
  category_name: string | null;
  color_class: string | null;
};

export const fetchServicesForDateSelection = async (params: {
  storeId: number;
  date: string;
  staffId?: number;
  anyone?: boolean;
}): Promise<ServiceForDateSelection[]> => {
  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-date/services`);
  url.searchParams.set('store_id', String(params.storeId));
  url.searchParams.set('date', params.date);
  if (params.staffId && Number.isFinite(params.staffId) && params.staffId > 0) {
    url.searchParams.set('staff_id', String(params.staffId));
  }
  if (params.anyone) {
    url.searchParams.set('anyone', '1');
  }

  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as any).error || 'Failed to fetch services');
  }

  const data = (await res.json()) as ServiceForDateSelection[];
  return Array.isArray(data) ? data : [];
};
